import { useState } from 'react';
import { downloadFile } from '../api/hooks';
import { useT } from '../i18n';
import { useUi } from '../state/ui';
import { Btn } from './ui';

/** Serverový export seznamu do CSV / XLSX (kap. 15); tlačítka jsou malá, vedle filtrů. */
export function ExportButtons({
  kind,
  companyId,
  from,
  to,
}: {
  kind: 'contacts' | 'products' | 'stock' | 'movements' | 'payments' | 'documents' | 'series';
  companyId: string | null | undefined;
  from?: string;
  to?: string;
}) {
  const t = useT();
  const { toast } = useUi();
  const [busy, setBusy] = useState<'csv' | 'xlsx' | null>(null);
  if (!companyId) return null;
  const run = async (format: 'csv' | 'xlsx') => {
    setBusy(format);
    const params = new URLSearchParams({ companyId, format });
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    try {
      const name = await downloadFile(`/api/exports/${kind}?${params.toString()}`);
      toast(`Staženo ${name}`);
    } catch (e) {
      toast(e instanceof Error ? e.message : t('export.failed'));
    } finally {
      setBusy(null);
    }
  };
  return (
    <span className="export-btns">
      <Btn sm loading={busy === 'csv'} onClick={() => run('csv')}>
        Export CSV
      </Btn>
      <Btn sm loading={busy === 'xlsx'} onClick={() => run('xlsx')}>
        XLSX
      </Btn>
    </span>
  );
}
